import {
  form_control_styles_default
} from "./chunk.MQ3BRWJW.js";
import {
  LocalizeController
} from "./chunk.RQU6SOEM.js";
import {
  FormSubmitController,
  l as l2
} from "./chunk.NYKU5T7J.js";
import {
  HasSlotController
} from "./chunk.TQTLXOET.js";
import {
  o
} from "./chunk.ONXLNBOP.js";
import {
  emit
} from "./chunk.T3VOOO5F.js";
import {
  watch
} from "./chunk.H7XADNZ7.js";
import {
  l
} from "./chunk.Z4OOI5NQ.js";
import {
  e,
  i2,
  n,
  t
} from "./chunk.5E26GMTR.js";
import {
  $,
  component_styles_default,
  r,
  s4
} from "./chunk.3PRAXUFA.js";
import {
  __decorateClass
} from "./chunk.7RPYXGIF.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.WVVUWAAN.js
var input_styles_default = r` ${component_styles_default} ${form_control_styles_default} :host { display: block; } .input { flex: 1 1 auto; display: inline-flex; align-items: stretch; justify-content: start; position: relative; width: 100%; font-family: var(--sl-input-font-family); font-weight: var(--sl-input-font-weight); letter-spacing: var(--sl-input-letter-spacing); vertical-align: middle; overflow: hidden; cursor: text; transition: var(--sl-transition-fast) color, var(--sl-transition-fast) border, var(--sl-transition-fast) box-shadow, var(--sl-transition-fast) background-color; } /* Standard inputs */ .input--standard { background-color: var(--sl-input-background-color); border: solid var(--sl-input-border-width) var(--sl-input-border-color); } .input--standard:hover:not(.input--disabled) { background-color: var(--sl-input-background-color-hover); border-color: var(--sl-input-border-color-hover); } .input--standard.input--focused:not(.input--disabled) { background-color: var(--sl-input-background-color-focus); border-color: var(--sl-input-border-color-focus); box-shadow: var(--sl-focus-ring); } .input--standard.input--focused:not(.input--disabled) .input__control { color: var(--sl-input-color-focus); } .input--standard.input--disabled { background-color: var(--sl-input-background-color-disabled); border-color: var(--sl-input-border-color-disabled); opacity: 0.5; cursor: not-allowed; } .input--standard.input--disabled .input__control { color: var(--sl-input-color-disabled); } .input--standard.input--disabled .input__control::placeholder { color: var(--sl-input-placeholder-color-disabled); } /* Filled inputs */ .input--filled { border: none; background-color: var(--sl-input-filled-background-color); color: var(--sl-input-color); } .input--filled:hover:not(.input--disabled) { background-color: var(--sl-input-filled-background-color-hover); } .input--filled.input--focused:not(.input--disabled) { background-color: var(--sl-input-filled-background-color-focus); box-shadow: var(--sl-focus-ring); } .input--filled.input--disabled { background-color: var(--sl-input-filled-background-color-disabled); opacity: 0.5; cursor: not-allowed; } .input__control { flex: 1 1 auto; font-family: inherit; font-size: inherit; font-weight: inherit; min-width: 0; height: 100%; color: var(--sl-input-color); border: none; background: none; box-shadow: none; padding: 0; margin: 0; cursor: inherit; -webkit-appearance: none; } .input__control::-webkit-search-decoration, .input__control::-webkit-search-cancel-button, .input__control::-webkit-search-results-button, .input__control::-webkit-search-results-decoration { -webkit-appearance: none; } .input__control:-webkit-autofill, .input__control:-webkit-autofill:hover, .input__control:-webkit-autofill:focus, .input__control:-webkit-autofill:active { box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-background-color-hover) inset !important; -webkit-text-fill-color: var(--sl-color-primary-500); caret-color: var(--sl-input-color); } .input--filled .input__control:-webkit-autofill, .input--filled .input__control:-webkit-autofill:hover, .input--filled .input__control:-webkit-autofill:focus, .input--filled .input__control:-webkit-autofill:active { box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-filled-background-color) inset !important; } .input__control::placeholder { color: var(--sl-input-placeholder-color); user-select: none; } .input:hover:not(.input--disabled) .input__control { color: var(--sl-input-color-hover); } .input__control:focus { outline: none; } .input__prefix, .input__suffix { display: inline-flex; flex: 0 0 auto; align-items: center; cursor: default; } .input__prefix ::slotted(sl-icon), .input__suffix ::slotted(sl-icon) { color: var(--sl-input-icon-color); } /* * Size modifiers */ .input--small { border-radius: var(--sl-input-border-radius-small); font-size: var(--sl-input-font-size-small); height: var(--sl-input-height-small); } .input--small .input__control { height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2); padding: 0 var(--sl-input-spacing-small); } .input--small .input__clear, .input--small .input__password-toggle { width: calc(1em + var(--sl-input-spacing-small) * 2); } .input--small .input__prefix ::slotted(*) { padding-left: var(--sl-input-spacing-small); } .input--small .input__suffix ::slotted(*) { padding-right: var(--sl-input-spacing-small); } .input--medium { border-radius: var(--sl-input-border-radius-medium); font-size: var(--sl-input-font-size-medium); height: var(--sl-input-height-medium); } .input--medium .input__control { height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2); padding: 0 var(--sl-input-spacing-medium); } .input--medium .input__clear, .input--medium .input__password-toggle { width: calc(1em + var(--sl-input-spacing-medium) * 2); } .input--medium .input__prefix ::slotted(*) { padding-left: var(--sl-input-spacing-medium); } .input--medium .input__suffix ::slotted(*) { padding-right: var(--sl-input-spacing-medium); } .input--large { border-radius: var(--sl-input-border-radius-large); font-size: var(--sl-input-font-size-large); height: var(--sl-input-height-large); } .input--large .input__control { height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2); padding: 0 var(--sl-input-spacing-large); } .input--large .input__clear, .input--large .input__password-toggle { width: calc(1em + var(--sl-input-spacing-large) * 2); } .input--large .input__prefix ::slotted(*) { padding-left: var(--sl-input-spacing-large); } .input--large .input__suffix ::slotted(*) { padding-right: var(--sl-input-spacing-large); } /* * Pill modifier */ .input--pill.input--small { border-radius: var(--sl-input-height-small); } .input--pill.input--medium { border-radius: var(--sl-input-height-medium); } .input--pill.input--large { border-radius: var(--sl-input-height-large); } /* * Clearable + Password Toggle */ .input__clear, .input__password-toggle { display: inline-flex; align-items: center; justify-content: center; font-size: inherit; color: var(--sl-input-icon-color); border: none; background: none; padding: 0; transition: var(--sl-transition-fast) color; cursor: pointer; } .input__clear:hover, .input__password-toggle:hover { color: var(--sl-input-icon-color-hover); } .input__clear:focus, .input__password-toggle:focus { outline: none; } .input--empty .input__clear { visibility: hidden; } /* Don't show the browser's password toggle in Edge */ ::-ms-reveal { display: none; } `;

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.TZDCDFV4.js
var SlInput = class extends s4 {
  constructor() {
    super(...arguments);
    this.formSubmitController = new FormSubmitController(this);
    this.hasSlotController = new HasSlotController(this, "help-text", "label");
    this.localize = new LocalizeController(this);
    this.hasFocus = false;
    this.isPasswordVisible = false;
    this.type = "text";
    this.size = "medium";
    this.value = "";
    this.filled = false;
    this.pill = false;
    this.label = "";
    this.helpText = "";
    this.clearable = false;
    this.togglePassword = false;
    this.disabled = false;
    this.readonly = false;
    this.required = false;
    this.invalid = false;
  }
  get valueAsDate() {
    var _a, _b;
    return (_b = (_a = this.input) == null ? void 0 : _a.valueAsDate) != null ? _b : null;
  }
  set valueAsDate(newValue) {
    this.updateComplete.then(() => {
      this.input.valueAsDate = newValue;
      this.value = this.input.value;
    });
  }
  get valueAsNumber() {
    var _a, _b;
    return (_b = (_a = this.input) == null ? void 0 : _a.valueAsNumber) != null ? _b : parseFloat(this.value);
  }
  set valueAsNumber(newValue) {
    this.updateComplete.then(() => {
      this.input.valueAsNumber = newValue;
      this.value = this.input.value;
    });
  }
  firstUpdated() {
    this.invalid = !this.input.checkValidity();
  }
  focus(options) {
    this.input.focus(options);
  }
  blur() {
    this.input.blur();
  }
  select() {
    this.input.select();
  }
  setSelectionRange(selectionStart, selectionEnd, selectionDirection = "none") {
    this.input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
  }
  setRangeText(replacement, start, end, selectMode = "preserve") {
    this.input.setRangeText(replacement, start, end, selectMode);
    if (this.value !== this.input.value) {
      this.value = this.input.value;
      emit(this, "sl-input");
      emit(this, "sl-change");
    }
  }
  reportValidity() {
    return this.input.reportValidity();
  }
  setCustomValidity(message) {
    this.input.setCustomValidity(message);
    this.invalid = !this.input.checkValidity();
  }
  handleBlur() {
    this.hasFocus = false;
    emit(this, "sl-blur");
  }
  handleChange() {
    this.value = this.input.value;
    emit(this, "sl-change");
  }
  handleClearClick(event) {
    this.value = "";
    emit(this, "sl-clear");
    emit(this, "sl-input");
    emit(this, "sl-change");
    this.input.focus();
    event.stopPropagation();
  }
  handleDisabledChange() {
    this.input.disabled = this.disabled;
    this.invalid = !this.input.checkValidity();
  }
  handleFocus() {
    this.hasFocus = true;
    emit(this, "sl-focus");
  }
  handleInput() {
    this.value = this.input.value;
    emit(this, "sl-input");
  }
  handleInvalid() {
    this.invalid = true;
  }
  handleKeyDown(event) {
    const hasModifier = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    if (event.key === "Enter" && !hasModifier) {
      this.formSubmitController.submit();
    }
  }
  handlePasswordToggle() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  handleValueChange() {
    this.invalid = !this.input.checkValidity();
  }
  render() {
    const hasLabelSlot = this.hasSlotController.test("label");
    const hasHelpTextSlot = this.hasSlotController.test("help-text");
    const hasLabel = this.label ? true : !!hasLabelSlot;
    const hasHelpText = this.helpText ? true : !!hasHelpTextSlot;
    return $`<div part="form-control" class=${o({
      "form-control": true,
      "form-control--small": this.size === "small",
      "form-control--medium": this.size === "medium",
      "form-control--large": this.size === "large",
      "form-control--has-label": hasLabel,
      "form-control--has-help-text": hasHelpText
    })} ><label part="form-control-label" class="form-control__label" for="input" aria-hidden=${hasLabel ? "false" : "true"} ><slot name="label">${this.label}</slot></label><div part="form-control-input" class="form-control-input"><div part="base" class=${o({
      input: true,
      "input--small": this.size === "small",
      "input--medium": this.size === "medium",
      "input--large": this.size === "large",
      "input--pill": this.pill,
      "input--standard": !this.filled,
      "input--filled": this.filled,
      "input--disabled": this.disabled,
      "input--focused": this.hasFocus,
      "input--empty": this.value.length === 0,
      "input--invalid": this.invalid
    })} ><span part="prefix" class="input__prefix"><slot name="prefix"></slot></span><input part="input" id="input" class="input__control" type=${this.type === "password" && this.isPasswordVisible ? "text" : this.type} name=${l(this.name)} ?disabled=${this.disabled} ?readonly=${this.readonly} ?required=${this.required} placeholder=${l(this.placeholder)} minlength=${l(this.minlength)} maxlength=${l(this.maxlength)} min=${l(this.min)} max=${l(this.max)} step=${l(this.step)} .value=${l2(this.value)} autocapitalize=${l(this.autocapitalize)} autocomplete=${l(this.autocomplete)} autocorrect=${l(this.autocorrect)} ?autofocus=${this.autofocus} spellcheck=${l(this.spellcheck)} pattern=${l(this.pattern)} enterkeyhint=${l(this.enterkeyhint)} inputmode=${l(this.inputmode)} aria-describedby="help-text" aria-invalid=${this.invalid ? "true" : "false"} @change=${this.handleChange} @input=${this.handleInput} @invalid=${this.handleInvalid} @keydown=${this.handleKeyDown} @focus=${this.handleFocus} @blur=${this.handleBlur} />${this.clearable && this.value.length > 0 ? $`<button part="clear-button" class="input__clear" type="button" aria-label=${this.localize.term("clearEntry")} @click=${this.handleClearClick} tabindex="-1" ><slot name="clear-icon"><sl-icon name="x-circle-fill" library="system"></sl-icon></slot></button>` : ""} ${this.togglePassword ? $`<button part="password-toggle-button" class="input__password-toggle" type="button" aria-label=${this.localize.term(this.isPasswordVisible ? "hidePassword" : "showPassword")} @click=${this.handlePasswordToggle} tabindex="-1" >${this.isPasswordVisible ? $`<slot name="show-password-icon"><sl-icon name="eye-slash" library="system"></sl-icon></slot>` : $`<slot name="hide-password-icon"><sl-icon name="eye" library="system"></sl-icon></slot>`}</button>` : ""}<span part="suffix" class="input__suffix"><slot name="suffix"></slot></span></div></div><div part="form-control-help-text" id="help-text" class="form-control__help-text" aria-hidden=${hasHelpText ? "false" : "true"} ><slot name="help-text">${this.helpText}</slot></div></div>`;
  }
};
SlInput.styles = input_styles_default;
__decorateClass([
  i2(".input__control")
], SlInput.prototype, "input", 2);
__decorateClass([
  t()
], SlInput.prototype, "hasFocus", 2);
__decorateClass([
  t()
], SlInput.prototype, "isPasswordVisible", 2);
__decorateClass([
  e({ reflect: true })
], SlInput.prototype, "type", 2);
__decorateClass([
  e({ reflect: true })
], SlInput.prototype, "size", 2);
__decorateClass([
  e()
], SlInput.prototype, "name", 2);
__decorateClass([
  e()
], SlInput.prototype, "value", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlInput.prototype, "filled", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlInput.prototype, "pill", 2);
__decorateClass([
  e()
], SlInput.prototype, "label", 2);
__decorateClass([
  e({ attribute: "help-text" })
], SlInput.prototype, "helpText", 2);
__decorateClass([
  e({ type: Boolean })
], SlInput.prototype, "clearable", 2);
__decorateClass([
  e({ attribute: "toggle-password", type: Boolean })
], SlInput.prototype, "togglePassword", 2);
__decorateClass([
  e()
], SlInput.prototype, "placeholder", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlInput.prototype, "disabled", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlInput.prototype, "readonly", 2);
__decorateClass([
  e({ type: Number })
], SlInput.prototype, "minlength", 2);
__decorateClass([
  e({ type: Number })
], SlInput.prototype, "maxlength", 2);
__decorateClass([
  e()
], SlInput.prototype, "min", 2);
__decorateClass([
  e()
], SlInput.prototype, "max", 2);
__decorateClass([
  e({ type: Number })
], SlInput.prototype, "step", 2);
__decorateClass([
  e()
], SlInput.prototype, "pattern", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlInput.prototype, "required", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlInput.prototype, "invalid", 2);
__decorateClass([
  e()
], SlInput.prototype, "autocapitalize", 2);
__decorateClass([
  e()
], SlInput.prototype, "autocorrect", 2);
__decorateClass([
  e()
], SlInput.prototype, "autocomplete", 2);
__decorateClass([
  e({ type: Boolean })
], SlInput.prototype, "autofocus", 2);
__decorateClass([
  e()
], SlInput.prototype, "enterkeyhint", 2);
__decorateClass([
  e({ type: Boolean })
], SlInput.prototype, "spellcheck", 2);
__decorateClass([
  e()
], SlInput.prototype, "inputmode", 2);
__decorateClass([
  watch("disabled", { waitUntilFirstUpdate: true })
], SlInput.prototype, "handleDisabledChange", 1);
__decorateClass([
  watch("value", { waitUntilFirstUpdate: true })
], SlInput.prototype, "handleValueChange", 1);
SlInput = __decorateClass([
  n("sl-input")
], SlInput);
